import { Grid } from '@design-systems/canvas-ui'
import './guest.css'
import { BasicPlaceholder } from 'components/placeholder'
import { ErrorAlert } from 'components/error-fallback'
import { useMyTargetPerformanceGuestMetrics } from 'hooks/myTarget-performance/useMyTargetPerformanceGuestMetrics'
import { useMyTargetPerformanceGuestGoals } from 'hooks/myTarget-performance/useMyTargetPerformanceGuestGoals'
import { useMyTargetPerformanceTab } from 'hooks/myTarget-performance/useMyTargetPerformanceTab'
import { PerformanceMetricCards } from './performance-metric-cards'

export const Guest = () => {
    const {
        filteredMetrics,
        dataByTimeDimension,
        goalsData,
        isLoading,
        isError,
        error,
        refetch,
    } = useMyTargetPerformanceTab({
        useMetricsHook: useMyTargetPerformanceGuestMetrics,
        useGoalsHook: useMyTargetPerformanceGuestGoals,
    })

    if (isLoading) {
        return (
            <div
                className="placeholder-container hc8-pt-6x"
                data-testid="placeholder"
            >
                <BasicPlaceholder type="table" rows={5} columns={3} />
            </div>
        )
    }

    if (isError) {
        return <ErrorAlert error={error} onRetry={() => refetch()} />
    }

    return (
        <Grid.Container>
            <PerformanceMetricCards
                data={filteredMetrics}
                dataByTimeDimension={dataByTimeDimension}
                goalsData={goalsData}
                tabName="guest"
            />
        </Grid.Container>
    )
}
